// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file artifacts/v1/model.proto (package artifacts.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file artifacts/v1/model.proto.
 */
export const file_artifacts_v1_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message artifacts.v1.Artifact
 */
export type Artifact = Message<"artifacts.v1.Artifact"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp date_added = 2;
   */
  dateAdded?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp date_updated = 3;
   */
  dateUpdated?: Timestamp;

  /**
   * @generated from field: optional string name = 4;
   */
  name?: string;

  /**
   * @generated from field: artifacts.v1.DocumentSource source = 5;
   */
  source: DocumentSource;

  /**
   * @generated from field: optional string artifact_subcategory = 6;
   */
  artifactSubcategory?: string;

  /**
   * @generated from field: string artifact_category = 7;
   */
  artifactCategory: string;

  /**
   * @generated from oneof artifacts.v1.Artifact.artifact
   */
  artifact: {
    /**
     * @generated from field: string artifact_id = 8;
     */
    value: string;
    case: "artifactId";
  } | {
    /**
     * @generated from field: string artifact_link = 9;
     */
    value: string;
    case: "artifactLink";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: artifacts.v1.DocumentStatus status = 10;
   */
  status: DocumentStatus;

  /**
   * @generated from field: optional string company_id = 11;
   */
  companyId?: string;

  /**
   * @generated from field: optional artifacts.v1.DocumentError error = 12;
   */
  error?: DocumentError;

  /**
   * @generated from field: optional google.protobuf.Timestamp expiration_date = 13;
   */
  expirationDate?: Timestamp;

  /**
   * @generated from field: artifacts.v1.ArtifactClassification classification = 14;
   */
  classification: ArtifactClassification;

  /**
   * Latest revision ID for public artifacts; empty for org documents
   *
   * @generated from field: optional string latest_revision_id = 15;
   */
  latestRevisionId?: string;

  /**
   * @generated from field: bool archived = 16;
   */
  archived: boolean;
};

/**
 * Describes the message artifacts.v1.Artifact.
 * Use `create(ArtifactSchema)` to create a new message.
 */
export const ArtifactSchema: GenMessage<Artifact> = /*@__PURE__*/
  messageDesc(file_artifacts_v1_model, 0);

/**
 * @generated from message artifacts.v1.QuoteEntry
 */
export type QuoteEntry = Message<"artifacts.v1.QuoteEntry"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: string context = 2;
   */
  context: string;
};

/**
 * Describes the message artifacts.v1.QuoteEntry.
 * Use `create(QuoteEntrySchema)` to create a new message.
 */
export const QuoteEntrySchema: GenMessage<QuoteEntry> = /*@__PURE__*/
  messageDesc(file_artifacts_v1_model, 1);

/**
 * @generated from message artifacts.v1.DocumentQuote
 */
export type DocumentQuote = Message<"artifacts.v1.DocumentQuote"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: optional string subcategory = 2;
   */
  subcategory?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp expiration_date = 3;
   */
  expirationDate?: Timestamp;

  /**
   * @generated from field: optional int32 page = 5;
   */
  page?: number;

  /**
   * @generated from field: artifacts.v1.DocumentSource source = 6;
   */
  source: DocumentSource;

  /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 7;
   */
  uploadedAt?: Timestamp;

  /**
   * @generated from oneof artifacts.v1.DocumentQuote.quote
   */
  quote: {
    /**
     * @generated from field: artifacts.v1.PublicArtifact artifact = 8;
     */
    value: PublicArtifact;
    case: "artifact";
  } | {
    /**
     * @generated from field: string org_artifact_id = 9;
     */
    value: string;
    case: "orgArtifactId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: repeated artifacts.v1.QuoteEntry quote_entries = 11;
   */
  quoteEntries: QuoteEntry[];
};

/**
 * Describes the message artifacts.v1.DocumentQuote.
 * Use `create(DocumentQuoteSchema)` to create a new message.
 */
export const DocumentQuoteSchema: GenMessage<DocumentQuote> = /*@__PURE__*/
  messageDesc(file_artifacts_v1_model, 2);

/**
 * @generated from message artifacts.v1.PublicArtifact
 */
export type PublicArtifact = Message<"artifacts.v1.PublicArtifact"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message artifacts.v1.PublicArtifact.
 * Use `create(PublicArtifactSchema)` to create a new message.
 */
export const PublicArtifactSchema: GenMessage<PublicArtifact> = /*@__PURE__*/
  messageDesc(file_artifacts_v1_model, 3);

/**
 * @generated from enum artifacts.v1.DocumentStatus
 */
export enum DocumentStatus {
  /**
   * @generated from enum value: DOCUMENT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DOCUMENT_STATUS_COMPLETE = 1;
   */
  COMPLETE = 1,

  /**
   * @generated from enum value: DOCUMENT_STATUS_PENDING = 2;
   */
  PENDING = 2,

  /**
   * @generated from enum value: DOCUMENT_STATUS_CLASSIFYING = 3;
   */
  CLASSIFYING = 3,

  /**
   * For backward compatibility with existing past assessments
   *
   * @generated from enum value: DOCUMENT_STATUS_ANALYZING = 4;
   */
  ANALYZING = 4,
}

/**
 * Describes the enum artifacts.v1.DocumentStatus.
 */
export const DocumentStatusSchema: GenEnum<DocumentStatus> = /*@__PURE__*/
  enumDesc(file_artifacts_v1_model, 0);

/**
 * @generated from enum artifacts.v1.DocumentError
 */
export enum DocumentError {
  /**
   * @generated from enum value: DOCUMENT_ERROR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DOCUMENT_ERROR_UNKNOWN_ERROR = 1;
   */
  UNKNOWN_ERROR = 1,

  /**
   * @generated from enum value: DOCUMENT_ERROR_UNSUPPORTED_TYPE = 2;
   */
  UNSUPPORTED_TYPE = 2,

  /**
   * @generated from enum value: DOCUMENT_ERROR_ENCRYPTED = 3;
   */
  ENCRYPTED = 3,

  /**
   * @generated from enum value: DOCUMENT_ERROR_EMPTY = 4;
   */
  EMPTY = 4,

  /**
   * @generated from enum value: DOCUMENT_ERROR_UNKNOWN_CATEGORY = 5;
   */
  UNKNOWN_CATEGORY = 5,

  /**
   * @generated from enum value: DOCUMENT_ERROR_UNKNOWN_COMPANY = 6;
   */
  UNKNOWN_COMPANY = 6,

  /**
   * @generated from enum value: DOCUMENT_ERROR_NO_TEXT_EXTRACTED = 7;
   */
  NO_TEXT_EXTRACTED = 7,
}

/**
 * Describes the enum artifacts.v1.DocumentError.
 */
export const DocumentErrorSchema: GenEnum<DocumentError> = /*@__PURE__*/
  enumDesc(file_artifacts_v1_model, 1);

/**
 * @generated from enum artifacts.v1.DocumentSource
 */
export enum DocumentSource {
  /**
   * @generated from enum value: DOCUMENT_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DOCUMENT_SOURCE_MANUAL_UPLOAD = 1;
   */
  MANUAL_UPLOAD = 1,

  /**
   * @generated from enum value: DOCUMENT_SOURCE_INTEGRATION = 2;
   */
  INTEGRATION = 2,

  /**
   * used to hint that this doucment was fetched from the world wide web (not from the web-ui)
   *
   * @generated from enum value: DOCUMENT_SOURCE_WEB = 3;
   */
  WEB = 3,

  /**
   * used to hint that the company was provided by the user and not inferred
   *
   * @generated from enum value: DOCUMENT_SOURCE_MANUAL_UPLOAD_WITH_COMPANY = 4;
   */
  MANUAL_UPLOAD_WITH_COMPANY = 4,

  /**
   * the document was collected using the Lema Questionnaire module
   *
   * @generated from enum value: DOCUMENT_SOURCE_LEMA_QUESTIONNAIRE = 5;
   */
  LEMA_QUESTIONNAIRE = 5,

  /**
   * used to hint that the company and category were provided by the user and not inferred
   *
   * @generated from enum value: DOCUMENT_SOURCE_MANUAL_UPLOAD_WITH_COMPANY_AND_CATEGORY = 6;
   */
  MANUAL_UPLOAD_WITH_COMPANY_AND_CATEGORY = 6,
}

/**
 * Describes the enum artifacts.v1.DocumentSource.
 */
export const DocumentSourceSchema: GenEnum<DocumentSource> = /*@__PURE__*/
  enumDesc(file_artifacts_v1_model, 2);

/**
 * @generated from enum artifacts.v1.ArtifactClassification
 */
export enum ArtifactClassification {
  /**
   * @generated from enum value: ARTIFACT_CLASSIFICATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ARTIFACT_CLASSIFICATION_PRIVATE = 1;
   */
  PRIVATE = 1,

  /**
   * @generated from enum value: ARTIFACT_CLASSIFICATION_PUBLIC = 2;
   */
  PUBLIC = 2,
}

/**
 * Describes the enum artifacts.v1.ArtifactClassification.
 */
export const ArtifactClassificationSchema: GenEnum<ArtifactClassification> = /*@__PURE__*/
  enumDesc(file_artifacts_v1_model, 3);

/**
 * @generated from enum artifacts.v1.SOC2Scope
 */
export enum SOC2Scope {
  /**
   * @generated from enum value: SOC2_SCOPE_UNSPECIFIED = 0;
   */
  SOC2_SCOPE_UNSPECIFIED = 0,

  /**
   * CC
   *
   * @generated from enum value: SOC2_SCOPE_SECURITY = 1;
   */
  SOC2_SCOPE_SECURITY = 1,

  /**
   * A
   *
   * @generated from enum value: SOC2_SCOPE_AVAILABILITY = 2;
   */
  SOC2_SCOPE_AVAILABILITY = 2,

  /**
   * C
   *
   * @generated from enum value: SOC2_SCOPE_CONFIDENTIALITY = 3;
   */
  SOC2_SCOPE_CONFIDENTIALITY = 3,

  /**
   * P
   *
   * @generated from enum value: SOC2_SCOPE_PRIVACY = 4;
   */
  SOC2_SCOPE_PRIVACY = 4,

  /**
   * PI
   *
   * @generated from enum value: SOC2_SCOPE_PROCESSING = 5;
   */
  SOC2_SCOPE_PROCESSING = 5,
}

/**
 * Describes the enum artifacts.v1.SOC2Scope.
 */
export const SOC2ScopeSchema: GenEnum<SOC2Scope> = /*@__PURE__*/
  enumDesc(file_artifacts_v1_model, 4);

